import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link, useHistory, useParams } from "react-router-dom";
import columns from "./columns";
import { DataGrid } from "@material-ui/data-grid";
import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Jumbotron,
  Modal,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import API from "../../api/API";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import ConfirmModal from "../ConfirmModal";
import { useDeleteMutation, useMutationHandler } from "../../hooks/mutations";
import { useCreateToast } from "../../hooks/toasts";
import { Table } from "@material-ui/core";
import globalStyles from "../../util/styles";
import SpotEditForm from "../SpotForm/SpotEditForm";
const styles = {
  ...globalStyles,
  tile: {
    minHeight: 250,
  },
  gridDiv: { height: 400, width: "100%" },
};
const Spot = () => {
  const history = useHistory();
  const createToast = useCreateToast();
  let { id } = useParams();
  const { data: spotData } = useQuery(["spot", parseInt(id)], () =>
    API.spots.getOne(id)
  );
  const { data: seshData } = useQuery(["seshes", parseInt(id)], () =>
    API.spots.getSeshes(id)
  );
  const tideSources = spotData?.spot?.dataSources?.filter(
    (s) => s.category === "tide"
  );
  const swellSources = spotData?.spot?.dataSources?.filter(
    (s) => s.category === "swell"
  );
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal((prev) => !prev);
  const [showConfirm, setShowConfirm] = useState(false);

  const toggleConfirm = () => setShowConfirm((prev) => !prev);
  const deleteSpot = useDeleteMutation(API.spots);
  const deleteSuccess = () => {
    createToast("success", `Deleted ${spotData?.spot?.name}`);
    history.push("/home");
  };

  const onDelete = useMutationHandler(
    [["spots"], ["spot", id]],
    deleteSpot,
    deleteSuccess,
    () => createToast("error", "Error Deleting run")
  );

  const formatSeshes = (sesh) => ({
    ...sesh,
    swell1Height: sesh.swells[0]?.height,
    swell1Dir: sesh.swells[0]?.direction,
    swell1Period: sesh.swells[0]?.period,
    swell2Height: sesh.swells[1]?.height,
    swell2Dir: sesh.swells[1]?.direction,
    swell2Period: sesh.swells[1]?.period,
    swell3Height: sesh.swells[2]?.height,
    swell3Dir: sesh.swells[2]?.direction,
    swell3Period: sesh.swells[2]?.period,
    spot: sesh.spot.name,
  });
  const rows = seshData?.seshes?.map(formatSeshes);
  return (
    <>
      <Jumbotron className="pt-3">
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/spots">Spots</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>{spotData?.spot?.name}</BreadcrumbItem>
        </Breadcrumb>
        <Row>
          <Col xs={10}>
            <h2>{spotData?.spot?.name}</h2>
          </Col>
          <Col xs={2}>
            <UncontrolledDropdown size="sm">
              <DropdownToggle color="secondary">
                <FontAwesomeIcon icon={faEllipsisH} />
              </DropdownToggle>
              <DropdownMenu right color="secondary" className="shadow">
                <DropdownItem onClick={toggleModal}>Edit</DropdownItem>
                {/* <DropdownItem onClick={() => console.log("edit")}>
                  Edit
                </DropdownItem> */}
                <DropdownItem onClick={toggleConfirm}>Delete</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Card className="bg-light" style={styles.tile}>
              <CardBody>{spotData?.spot?.description}</CardBody>
            </Card>
          </Col>
          <Col xs={8} style={styles.tile}>
            <Card className="bg-light" style={styles.tile}>
              <CardBody>Current Surf Report coming soon...</CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12}>
            <h3>Seshes ({rows?.length})</h3>
          </Col>
          <Col xs={12}>
            <div style={styles.gridDiv}>
              <DataGrid rows={rows || []} columns={columns} autoPageSize />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6} className="mt-1">
            <h5>Swell Sources</h5>
            <Table responsive borderless style={styles.table}>
              <thead style={styles.tableBorder}>
                <tr>
                  <th>Name</th>
                  <th>Vendor</th>
                </tr>
              </thead>
              <tbody className="bg-light" style={styles.tableBorder}>
                {swellSources?.map(
                  (swellSource, ndx) =>
                    !swellSource._destroy && (
                      <tr key={ndx}>
                        <td>{swellSource.name}</td>
                        <td>{swellSource.vendor}</td>
                      </tr>
                    )
                )}
                {swellSources?.filter((s) => !s._destroy)?.length === 0 && (
                  <tr>
                    <td className="text-center" colSpan="3">
                      No Sources Added
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>

          <Col xs={6} className="mt-1">
            <h5>Tide Sources</h5>
            <Table responsive borderless style={styles.table}>
              <thead style={styles.tableBorder}>
                <tr>
                  <th>Name</th>
                  <th>Vendor</th>
                </tr>
              </thead>
              <tbody className="bg-light" style={styles.tableBorder}>
                {tideSources?.map(
                  (tideSource, ndx) =>
                    !tideSource._destroy && (
                      <tr key={ndx}>
                        <td>{tideSource.name}</td>
                        <td>{tideSource.vendor}</td>
                      </tr>
                    )
                )}
                {tideSources?.filter((s) => !s._destroy)?.length === 0 && (
                  <tr>
                    <td className="text-center" colSpan="3">
                      No Sources Added
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Jumbotron>
      <ConfirmModal
        title={`Delete ${spotData?.spot?.name}?`}
        color="danger"
        message="This will permanently delete this spot and all associated seshes"
        onSubmit={() => onDelete(spotData?.spot)}
        toggle={toggleConfirm}
        isOpen={showConfirm}
      />
      <Modal
        id="edit-modal"
        className="modal-fullscreen"
        isOpen={modal}
        toggle={toggleModal}
        size="lg"
        modalTransition={{ timeout: 50 }}
      >
        <SpotEditForm spot={spotData?.spot} onCancel={toggleModal} />
      </Modal>
    </>
  );
};

export default Spot;
